export const ru = {
    common: {
        appName: "ITR Agent",
        retry: "Повторить",
        loading: "Загрузка…",
        back: "Назад",
        cancel: "Отмена",
        user: "Пользователь",
        themeLight: "Светлая тема",
        themeDark: "Тёмная тема",
        themeSystem: "Системная тема",
        langRu: "Русский",
        langEn: "English",
        yes: "да",
        no: "нет",
    },
    nav: {
        section: "Разделы",
        dashboard: "Главная",
        settings: "Настройки",
        strategies: "Стратегии",
        orders: "Ордера",
        analytics: "Аналитика",
        pnlReport: "Позиции и PnL",
        journal: "Журнал исполнения",
        admin: "Администрирование",
        logout: "Выйти",
    },
    mode: {
        sandbox: "Песочница",
        live: "Боевой",
        scopeTitle: "Данные режима «{{mode}}»",
        sandboxScopeHint: "Учебный счёт T-Invest и внутренняя модель ITR — не боевой портфель.",
        liveScopeHint: "Боевой счёт T-Invest и ордера ITR с mode=live — реальные деньги.",
        itrDataHint: "Только ордера и позиции ITR Agent в выбранном режиме.",
        brokerDataHint: "Снимок реального счёта T-Invest для выбранного режима.",
        emptyLiveTrading: "На боевом режиме нет сделок ITR Agent — PnL и лимиты равны нулю.",
    },
    auth: {
        loginTitle: "Вход",
        registerTitle: "Регистрация",
        email: "Email",
        password: "Пароль",
        name: "Имя",
        submitLogin: "Войти",
        submitRegister: "Создать аккаунт",
        noAccount: "Нет аккаунта?",
        hasAccount: "Уже есть аккаунт?",
        linkRegister: "Регистрация",
        linkLogin: "Войти",
        loggingIn: "Вход…",
        registering: "Создание аккаунта…",
        errorLogin: "Ошибка авторизации",
        errorRegister: "Ошибка регистрации",
    },
    dashboard: {
        title: "Главная",
        summaryTitle: "Сводка ({{mode}})",
        portfolio: "Портфель",
        pnlDaily: "PnL за день",
        activeStrategies: "Активных стратегий",
        openOrders: "Открытых заявок",
        loadSummary: "Загрузка сводки…",
        emptySummary: "Сводка недоступна.",
    },
    monitor: {
        healthTitle: "Health-индикаторы",
        apiHealth: "API",
        apiHealthDetail: "WS подключений: {{ws}}, uptime {{uptime}}с",
        wsHealth: "WebSocket",
        timelineTitle: "Timeline событий",
        timelineEmpty: "События real-time пока не поступали.",
        watchlistHint: "Тикеры active-стратегий: {{tickers}}",
        alertsTitle: "Панель алертов",
        alertsEmpty: "Активных алертов нет.",
        alertFilterAll: "Все",
        alertFilterWarning: "Warn",
        alertFilterError: "Error",
        clearFiltered: "Очистить фильтр",
        clearAll: "Очистить всё",
        ack: "Ack",
        showHistory: "Показать историю",
        hideHistory: "Скрыть историю",
        eventDetailsTitle: "Детали события",
        noSelectedEvent: "Выберите событие из списка слева.",
        noDetails: "Без дополнительных деталей",
        eventType: "Тип",
        eventMode: "Режим",
        eventTime: "Время",
        eventId: "ID события",
        eventPayload: "Содержимое",
        filterAllTypes: "Все типы",
        filterSearch: "Поиск по событию или payload",
        filteredEmpty: "По фильтрам событий нет.",
        scaleNormalized: "Нормализованный",
        scaleAbsolute: "Абсолютный",
        window: {
            "30s": "30с",
            "1m": "1м",
            "5m": "5м",
            all: "Все",
        },
        lastPrice: "Последняя цена",
        priceDelta: "Изменение цены",
        signalsErrors: "Сигналы/Ошибки",
        absoluteHint: "Абсолютный режим: цена выбранного тикера {{ticker}} в исходных значениях.",
        normalizedHint: "Нормализованный режим: все тикеры приведены к базе 100 для честного сравнения динамики.",
        healthTimelineHint: "Шкала показывает недавнюю доступность сервиса: зелёный — доступно, жёлтый — нестабильно, красный — недоступно.",
        lastChange: "Последнее изменение",
        now: "Сейчас",
        signalAlert: "Новый сигнал стратегии ({{mode}})",
        signalRejectedAlert: "Сигнал отклонён: {{reason}}",
        wsErrorAlert: "Проблема соединения WebSocket: heartbeat timeout",
        marketDataHealth: "Market data",
        marketDataSource: "Источник",
        marketDataHint: "Primary heartbeat: до 12с — OK; при деградации используется fallback до 25с, иначе торговля блокируется.",
        marketDataSourceValue: {
            primary: "Primary",
            fallback: "Fallback",
        },
        pipelineStage: "Этап пайплайна",
        reasonCode: "Reason code",
        status: {
            up: "OK",
            degraded: "Нестабильно",
            down: "Недоступно",
        },
    },
    tokens: {
        title: "Токены API",
        cardHint: "Токен хранится в ITR Agent. «Добавлен» и «ротация» — политика приложения (90 дн.); блок T-Invest — после «Проверить». Даты выпуска в портале T-Bank API не отдаёт. При входе токены проверяются автоматически.",
        load: "Загрузка токенов…",
        empty: "Токены для выбранного режима не добавлены.",
        validate: "Проверить",
        save: "Сохранить",
        saving: "Сохранение…",
        edit: "Редактировать",
        add: "Добавить токен",
        creating: "Добавление…",
        valueLabel: "Значение токена",
        valuePlaceholder: "Введите API токен",
        validationRequired: "Введите значение токена",
        modeLabel: "Режим",
        editValid: "Токен валиден",
        valid: "валиден",
        updated: "обновлён",
        unsavedChanges: "Есть несохранённые изменения",
        statusCreated: "Токен {{mode}} успешно добавлен",
        statusValidated: "Токен {{mode}} успешно проверен",
        statusUpdated: "Токен {{mode}} успешно обновлён",
        statusRotatedDowntimeFree: "Секрет обновлён ({{mode}}): ротация без простоя — новый TTL и проверка зафиксированы.",
        statusRemoved: "Токен {{mode}} удалён",
        remove: "Удалить",
        removeConfirmTitle: "Удалить токен?",
        removeConfirmDescription: "Токен {{id}} будет удалён из ITR Agent. Секрет в портале T-Bank при этом не отзывается.",
        removing: "Удаление…",
        issuedAt: "Добавлен в ITR Agent",
        expiresAt: "Ротация (политика, 90 дн.)",
        rotateUntil: "Ротация до",
        lastValidation: "Последняя проверка",
        rotationZdt: "Ротация без простоя",
        rotationZdtYes: "поддерживается",
        rotationZdtNo: "нет",
        validationOutcome: {
            never: "не проверялся",
            ok: "успех",
            failed: "ошибка",
        },
        tinvestSection: "Данные T-Invest (GetInfo)",
        tinvestFetchedAt: "Снимок",
        tinvestAccounts: "Счетов доступно",
        tinvestTariff: "Тариф",
        tinvestPrem: "Премиум",
        tinvestQual: "Квал. инвестор",
        tinvestQualifiedInstruments: "Доступ после тестов",
        boolYes: "да",
        boolNo: "нет",
    },
    settings: {
        title: "Настройки",
        profileTitle: "Профиль пользователя",
        preferencesTitle: "Предпочтения интерфейса",
        userId: "ID пользователя",
        userName: "Имя",
        userEmail: "Email",
        language: "Язык",
        theme: "Тема",
        policyTitle: "Политики Strategy/Risk/Execution",
        policyHint: "Настройки оркестрации, риск-гейтов и исполнения заявок для выбранного режима.",
        pretradeTitle: "Pre-trade (price band и перенос позиций)",
        pretradeHint: "Допустимое отклонение цены LIMIT-заявки от последней рыночной. При превышении заявка отклоняется с кодом PRETRADE_LIMIT_PRICE_BAND. Здесь же — правило переноса позиции между стратегиями при открытых заявках.",
        pretradeModeNote: "Настройка для режима «{{mode}}». Переключатель sandbox/боевой выше задаёт, для какого режима сохраняется значение.",
        pretradePriceBand: "Price band, %",
        pretradePriceBandHint: "Сравнивается цена заявки с последней ценой из Redis (или market_price позиции). По умолчанию 3%; для волатильных бумаг часто ставят 5–8%.",
        pretradePriceBandValidation: "Укажите price band от 0,1% до 50%.",
        pretradeTransferOpenOrders: "Перенос позиции при открытых заявках",
        pretradeTransferOpenOrdersHint: "По умолчанию перенос запрещён, пока по тикеру есть заявки со статусом open (включая TWAP parent). Разрешение — на свой риск: ордера останутся у исходной стратегии.",
        pretradeTransferForbid: "Запрещать",
        pretradeTransferAllow: "Разрешать",
        pretradeSave: "Сохранить pre-trade",
        pretradeSaved: "Сохранено",
        shadowRolloutTitle: "Shadow rollout (live)",
        shadowRolloutHint: "Автоматически переводить live-заявки в теневой режим (без реальных денег). Нужно, пока prod-исполнение выключено.",
        shadowRolloutScopeNote: "Настройка всегда относится к режиму Live. Переключатель sandbox/боевой выше (токены, риск) на shadow rollout не влияет.",
        shadowRolloutEnabled: "Включить shadow rollout для live-заявок",
        shadowRolloutCanary: "Canary, % (справочно)",
        shadowRolloutCanaryHint: "Поле сохраняется в policy; сейчас whitelist/enabled важнее canary.",
        shadowRolloutStrategies: "Whitelist стратегий (CSV id)",
        shadowRolloutStrategiesHint: "Пусто = все стратегии режима. Иначе только указанные id.",
        shadowRolloutAccounts: "Whitelist аккаунтов (CSV user id)",
        shadowRolloutAccountsHint: "Пусто = текущий пользователь не ограничивается whitelist аккаунтов.",
        shadowRolloutAlt: "Альтернатива: на странице Ордера включите галочку «Теневой режим» у конкретной заявки.",
        shadowRolloutSave: "Сохранить shadow rollout",
        shadowRolloutSaved: "Сохранено",
        riskPolicySection: "RiskPolicy (расширенные лимиты)",
        executionPolicySection: "ExecutionPolicy",
        venueRoutingHint: "Маршрутизация влияет на исполнение T-Invest: primary и failover выбирают FIGI/площадку. При отсутствии инструмента на площадке — один retry на следующую (moex/spb). OTC не поддерживается API — не включайте в failover.",
        primaryVenue: "Основная площадка (venue)",
        venueFailover1: "Failover, площадка 1",
        venueFailover2: "Failover, площадка 2",
        venueNone: "— не задана —",
        venueSwitchCriterion: "Критерий переключения между площадками",
        venue: {
            moex: "MOEX (биржевой основной рынок)",
            spb: "СПб Биржа",
            otc: "OTC / внебиржа",
        },
        venueSwitch: {
            min_spread_bps: "Мин. спред (bps) — вторая площадка в цепочке",
            max_top_of_book: "Макс. глубина стакана — последняя в цепочке",
            lowest_latency: "Мин. задержка — первая в цепочке failover",
        },
        portfolioAllocatorSection: "Распределение портфеля",
        portfolioAllocatorHint: "Позиция — текущая экспозиция по открытым позициям (qty × рыночная цена). Это справочная оценка риска в портфеле.",
        portfolioAllocatorPretradeHint: "Оборот за день — сумма исполненных заявок с начала суток (qty × lot × price). Именно она проверяется в pretrade для лимитов стратегии и кластера; новая заявка блокируется, если оборот уже достиг лимита.",
        portfolioLimitLabel: "Лимит",
        portfolioPositionLoad: "Позиция: {{amount}} ({{pct}}%)",
        portfolioTurnoverLoad: "Оборот за день (pretrade): {{amount}} ({{pct}}%)",
        portfolioPretradeBlocks: "блокирует новые заявки",
        portfolioPretradeNearLimit: "мало запаса — новые покупки могут отклоняться",
        portfolioTurnoverToday: "Суммарный оборот за день по режиму: {{amount}} ₽",
        portfolioKpiRejectTitle: "Доля отклонений (PORTFOLIO_LIMIT_*)",
        portfolioKpiOfMax: "порог",
        portfolioKpiAttempts: "попыток",
        portfolioKpiRej: "портфельных отклонений",
        portfolioKpiRejectOk: "KPI по доле отклонений выполняется (ниже порога).",
        portfolioKpiRejectNo: "Доля отклонений не ниже порога DoD.",
        portfolioKpiLiveNetTitle: "Net exposure после исполнения (live)",
        portfolioKpiLiveOverage: "Случаев «просачивания» выше cap",
        portfolioKpiLiveOk: "Превышений net exposure в live не зафиксировано.",
        portfolioKpiLiveNo: "Есть post-trade превышение net exposure (mock: после исполнения по фактической цене).",
        portfolioKpiUnavailable: "KPI портфельного слоя недоступны (эндпоинт не отвечает).",
        portfolioMaxRejectRatePct: "Порог DoD: макс. доля отклонений по портфельным кодам (%)",
        portfolioCapsValidation: "Лимиты портфеля (бюджет, net/gross exposure) должны быть числами больше 0.",
        portfolioTotalBudget: "Общий бюджет портфеля",
        portfolioNetExposureCap: "Net exposure cap",
        portfolioGrossExposureCap: "Gross exposure cap",
        portfolioUsed: "Использовано",
        portfolioUtilization: "Загрузка",
        portfolioStrategies: "Лимиты по стратегиям",
        portfolioClusters: "Лимиты по секторам/кластерам",
        portfolioNoRows: "Нет настроенных лимитов.",
        maxPositionNotional: "Лимит позиции (notional)",
        maxSimultaneousPositions: "Макс. одновременных позиций",
        allowedTickers: "Разрешённые тикеры (через запятую)",
        blockedTickers: "Заблокированные тикеры (через запятую)",
        maxExposurePerTicker: "Макс. экспозиция на тикер",
        maxOrdersPerTickerPerHour: "Макс. заявок на тикер в час",
        slippageThresholdBps: "Порог проскальзывания (bps)",
        commissionRatePct: "Комиссия брокера, % (на сторону сделки)",
        volatilityGuardEnabled: "Включить volatility guard",
        fieldHint: {
            totalBudgetNotional: "Потолок оборота/бюджета режима (₽). Новая заявка, после которой дневной оборот превысит лимит, отклоняется (PORTFOLIO_LIMIT_TOTAL_BUDGET).",
            netExposureCapNotional: "Макс. чистая экспозиция |сумма qty×цена| после ордера. Лонги и шорты частично гасятся. Частый узкий лимит при long-only книге.",
            grossExposureCapNotional: "Макс. валовая экспозиция: сумма |qty×цена| без неттинга. Растёт быстрее net, если есть и лонги, и шорты.",
            maxPositionNotional: "Максимальный номинал одной позиции (₽ ≈ qty × lot × цена). Новая заявка, которая превысит лимит, будет отклонена pretrade.",
            maxSimultaneousPositions: "Сколько разных открытых позиций можно держать одновременно. Меньше значение — меньше распыления капитала и параллельных минусов.",
            allowedTickers: "Белый список тикеров режима (через запятую). Пусто = без ограничения списка. Действует поверх StrategyPolicy: даже разрешённый в стратегии тикер может быть запрещён здесь.",
            blockedTickers: "Чёрный список режима: запрещает BUY и SELL по тикеру. Для паузы только покупок используйте «Блок покупок» на карточке тикера стратегии.",
            maxExposurePerTicker: "Потолок экспозиции (₽) на один тикер суммарно. Ограничивает концентрацию риска в одной бумаге.",
            maxOrdersPerTickerPerHour: "Анти-пила: максимум заявок по одному тикеру за час. Снижает серии BUY↔SELL и комиссии на шуме.",
            commissionRatePct: "Учётная комиссия на одну сторону сделки. Влияет на breakeven, PnL и правило «не продавать по MA ниже средней». Должна совпадать с тарифом брокера (часто ~0.3).",
            slippageThresholdBps: "Порог проскальзывания в базисных пунктах (1 bps = 0.01%). При превышении срабатывают риск-гейты / предупреждения по качеству исполнения.",
            volatilityGuardEnabled: "Доп. защита в периоды высокой волатильности: чаще блокирует или ужесточает вход, чтобы не ловить «шумные» сделки.",
        },
        routingProfile: "Профиль маршрутизации",
        limitOffsetBps: "Смещение лимит-цены (bps)",
        executionAdaptiveHint: "Адаптивный offset, нарезка (child orders) и fallback при мягкой деградации market data (primary устарел, fallback ещё в допуске; до полного блока по MD не доходит). В mock влияет на модель slippage/latency/partial fill.",
        adaptiveOffsetEnabled: "Адаптивное расширение смещения / доп. bps при плохой ликвидности",
        adaptiveOffsetMaxExtraBps: "Макс. доп. bps при деградации (cap)",
        maxChildOrderSlices: "Макс. число дочерних заявок (волн) при нарезке",
        minChildOrderQtyRatio: "Мин. доля объёма на волну (0…1)",
        liquidityDegradedFallback: "Поведение при ухудшении ликвидности (fallback)",
        liquidityFallback: {
            widen_offset: "Расширять offset (доп. slippage)",
            pause_slicing: "Отменить нарезку (одна волна)",
            widen_and_slow: "Расширять и замедлить (выше задержка)",
        },
        retryCount: "Повторные попытки",
        retryBackoffMs: "Задержка между повторами (ms)",
        partialFillTimeoutSec: "Таймаут partial fill (сек)",
        emergencyExitMode: "Режим аварийного выхода",
        cancelReplaceEnabled: "Включить cancel/replace",
        savePolicy: "Сохранить политики",
    },
    risk: {
        title: "Risk-панель",
        description: "Ограничения для режима {{mode}}",
        load: "Загрузка risk-настроек…",
        maxDailyLoss: "Дневной лимит убытка",
        maxWeeklyLoss: "Недельный лимит убытка",
        maxTradesPerDay: "Сделок в день (макс.)",
        maxNotionalPerDay: "Дневной лимит объёма",
        fieldHint: {
            maxDailyLoss: "Потолок реализованного убытка за календарный день (UTC, ₽). При достижении BUY/наращивание режутся; reduce-only SELL только в плюс (цена ≥ breakeven с комиссией). Stop-loss исключений не даёт.",
            maxWeeklyLoss: "То же за неделю. Срабатывает, даже если дневной лимит ещё не исчерпан.",
            maxTradesPerDay: "Жёсткий счётчик сделок за сутки. Главный рычаг против частой «пилы» и накопления комиссий. Reduce-only SELL не блокируется.",
            maxNotionalPerDay: "Суммарный оборот за день в ₽ (объём заявок), не число сделок. Ограничивает масштаб торговли; reduce-only SELL при исчерпании лимита разрешён.",
            killSwitchScope: "Область аварийной остановки: только выбранная стратегия, весь режим (sandbox/live) или весь аккаунт.",
            killSwitchStrategyId: "ID стратегии для области «Стратегия». Без корректного ID kill switch по strategy scope не сработает как ожидается.",
        },
        killSwitchEnabled: "Kill Switch включён: торговля остановлена",
        killSwitchDisabled: "Kill Switch выключен: торговля разрешена",
        killSwitchOnButton: "Включить Kill Switch",
        killSwitchOffButton: "Выключить Kill Switch",
        killSwitchControlTitle: "Kill Switch",
        killSwitchControlHint: "Аварийно останавливает или разрешает торговлю для выбранного режима.",
        killSwitchScope: "Область Kill Switch",
        killSwitchScopeStrategy: "Стратегия",
        killSwitchScopeMode: "Режим",
        killSwitchScopeAccount: "Аккаунт",
        killSwitchStrategyId: "Strategy ID для strategy scope",
        killSwitchScenario: "В боевом режиме включение kill switch требует подтверждения: останавливаются новые сигналы стратегий, блокируются новые и рабочие заявки, стратегии отключаются до выключения. В песочнице изменение применяется сразу.",
        killSwitchRunbook: "Runbook: после включения Kill Switch проверьте активные стратегии, отмените/проверьте рабочие заявки и убедитесь в стабилизации API/WS перед снятием блокировки.",
        switchOn: "Вкл",
        switchOff: "Выкл",
        save: "Сохранить лимиты",
        validation: "Проверьте значения лимитов: только неотрицательные числа, сделки — целое число.",
        updated: "Risk-лимиты обновлены",
        killSwitchOn: "Kill Switch активирован",
        killSwitchOff: "Kill Switch деактивирован",
    },
    strategies: {
        title: "Стратегии",
        backDashboard: "К обзору",
        createSection: "Новая стратегия",
        create: "Создать",
        namePlaceholder: "Название",
        defaultName: "Новая стратегия",
        load: "Загрузка стратегий…",
        empty: "Стратегий для выбранного режима пока нет.",
        emptyHint: "Создайте первую стратегию или откройте существующую.",
        listCount: "Стратегий: {{count}}",
        createOpen: "Создать стратегию",
        createCollapse: "Скрыть форму",
        cardActions: "Действия со стратегией",
        editorTabs: "Разделы стратегии",
        tabOverview: "Обзор",
        tabParams: "Параметры",
        tabPolicy: "Тикеры и policy",
        tabVersions: "Версии",
        active: "Активна",
        inactive: "Неактивна",
        accordionTickersEmpty: "Тикеры не заданы",
        accordionOpenMark: "открыта",
        accordionExpandHint: "Параметры и policy",
        autoTradingTitle: "Автоторговля (sandbox)",
        autoTradingRunning: "Runner активен — ордера выставляются по сигналу MA Cross",
        autoTradingNoSignals: "Сигналов пока нет (нужна история баров в Redis)",
        autoTradingLastSignal: "Последний сигнал",
        autoTradingLastOrder: "Последний ордер",
        autoTradingBarCount: "баров",
        exitHintsTitle: "Выход из позиции",
        exitPnlNow: "PnL позиции стратегии: {{pct}}%",
        exitTakeProfitRemaining: "До take-profit ({{target}}%): осталось {{pct}}%",
        exitTakeProfitReached: "Take-profit {{target}}% достигнут — ожидается SELL по защите",
        exitStopLossDistance: "До stop-loss (−{{target}}%): запас {{pct}}%",
        exitStopLossReached: "Stop-loss −{{target}}% достигнут — ожидается SELL",
        exitNoPosition: "Нет открытой позиции по этому тикеру для стратегии",
        exitMaSellNote: "SELL по MA — только при медвежьем пересечении fast/slow, не при росте цены",
        transferPosition: "Перенести позицию",
        transferSuccess: "Позиция {{ticker}} перенесена в «{{strategy}}».",
        lastSkipReason: "Последний пропуск сигнала",
        skipReason: {
            ma_buy_already_long: "Пропущен BUY: позиция уже открыта (long-only)",
            ma_sell_no_position: "Пропущен SELL: нет позиции для продажи",
            ma_sell_below_avg: "Пропущен SELL по MA: цена ниже средней (block_ma_sell_in_loss)",
            ma_sell_below_min_pnl: "Пропущен SELL по MA: прибыль ниже порога ma_sell_min_pnl_pct",
            pending_position_rules: "Отменён повтор сигнала: не подходит под правила позиции",
            pretrade: "Pretrade отклонил заявку: {{code}}",
        },
        modeLabel: "Режим",
        activate: "Активировать",
        deactivate: "Деактивировать",
        clone: "Клонировать",
        remove: "Удалить",
        statusCreated: "Стратегия создана",
        statusDeactivated: "Стратегия деактивирована",
        statusActivated: "Стратегия активирована",
        statusCloned: "Стратегия склонирована в {{mode}}",
        statusRemoved: "Стратегия удалена",
        statusUpdated: "Параметры стратегии сохранены",
        statusRenamed: "Название стратегии сохранено",
        nameRequired: "Укажите название стратегии.",
        statusRollback: "Выполнен rollback конфигурации стратегии",
        policySaved: "Policy стратегии сохранена",
        saveName: "Сохранить название",
        saveParams: "Сохранить параметры",
        versionsTitle: "Версии конфигурации",
        loadVersions: "Загрузить версии",
        versionsEmpty: "История версий пока не загружена.",
        rollback: "Rollback",
        policyTitle: "StrategyPolicy",
        policyPriority: "Приоритет",
        policyConflict: "Conflict policy",
        policyAllowedTickers: "Тикеры стратегии",
        tickerAdd: "Добавить",
        tickerRemove: "Удалить",
        tickerLockStopLoss: "Замок stop loss",
        tickerLockBuy: "Блок покупок",
        tickerDuplicate: "Тикер {{ticker}} уже в списке.",
        tickerInOtherStrategy: "Тикер {{ticker}} уже в стратегии «{{name}}». В одном режиме тикер может быть только в одной стратегии.",
        tickerOpenInOtherStrategy: "По тикеру {{ticker}} уже есть открытая позиция в стратегии «{{name}}». Закройте позицию или уберите тикер там.",
        policyExecutionProfile: "Execution profile",
        policyPreview: "Текущее правило",
        savePolicy: "Сохранить policy",
        policyGuardsSection: "Лимиты исполнения и окно времени",
        policyExpectedSlippageBps: "Ожидаемое slippage (bps)",
        policyMaxSpreadBps: "Макс. спред (bps)",
        policyMinLiquidityNotional: "Мин. ликвидность (номинал)",
        policySessionStart: "Начало сессии (HH:mm)",
        policySessionEnd: "Конец сессии (HH:mm)",
        policyTimezone: "Часовой пояс (IANA)",
        policyOnlyRth: "Только основная сессия (RTH)",
        policyOnlyRthYes: "Да",
        policyOnlyRthNo: "Нет",
        policyNewsBlackoutMinutes: "Новостной блэкаут (±мин, 0=выкл)",
        policyGuardsValidation: "Проверьте числовые лимиты: slippage/spread 0..500, ликвидность ≥0, блэкаут 0..240 целое.",
        policyScheduleValidation: "Проверьте окно времени: HH:mm и непустой timezone.",
        experimentTitle: "A/B эксперименты (legacy)",
        experimentHint: "Старый concurrent split; при exclusivity тикеров мало полезен. Предпочтите What-if выше.",
        whatIfTitle: "What-if эксперименты",
        whatIfHint: "Привязка к одной стратегии: на period_from факт и гипотеза стартуют с одних позиций (FIFO по ордерам до начала). Дальше гипотеза симулирует MA/SL/TP на барах — отчёт без PostOrder.",
        whatIfParamsHint: "Параметры ниже копируются из выбранной стратегии — меняйте только то, что проверяете. Симуляция: MA, SL/TP, MA SELL-правила, loss_avg (с дном), cooldown после MA-SELL, замок stop loss.",
        whatIfName: "Название",
        whatIfHypothesis: "Гипотеза",
        whatIfStrategy: "Стратегия",
        whatIfCreate: "Создать what-if",
        whatIfEmpty: "What-if экспериментов пока нет.",
        whatIfRunReport: "Построить отчёт",
        whatIfFact: "Факт",
        whatIfHyp: "Гипотеза",
        whatIfRec: "Рекомендация",
        whatIfByTicker: "Разрез по тикерам",
        whatIfTicker: "Тикер",
        whatIfRebuildReport: "Пересчитать отчёт",
        whatIfSignalsFact: "Сигналы (факт)",
        whatIfSignalsHyp: "Сигналы (гипотеза)",
        whatIfJournalFact: "Журнал сделок — факт",
        whatIfJournalHyp: "Журнал сделок — гипотеза",
        whatIfTradesEmpty: "Сделок за период нет.",
        whatIfColTime: "Время",
        whatIfColSide: "Сторона",
        whatIfColSignal: "Сигнал",
        whatIfColPrice: "Цена",
        whatIfColQty: "Лоты",
        whatIfOpening: "Старт (позиции на начало периода)",
        whatIfOpeningFlat: "плоско",
        whatIfEdit: "Изменить",
        whatIfSave: "Сохранить",
        whatIfSaveAndRebuild: "Сохранить и пересчитать",
        whatIfCancelEdit: "Отмена",
        whatIfDuplicate: "Дублировать",
        whatIfDelete: "Удалить",
        whatIfDeleteTitle: "Удалить what-if эксперимент?",
        whatIfDeleteDesc: "Эксперимент и сохранённый отчёт будут удалены без возможности восстановления.",
        whatIfUpdated: "What-if эксперимент обновлён",
        whatIfDeleted: "What-if эксперимент удалён",
        whatIfDuplicated: "What-if эксперимент скопирован",
        whatIfFilterTicker: "Тикер",
        whatIfFilterAll: "Все",
        whatIfParamsDiff: "Изменения params (baseline → hypothesis)",
        whatIfModelNotes: "Заметки модели",
        whatIfRecValue: {
            hypothesis_better: "гипотеза лучше",
            fact_better: "факт лучше",
            tie: "паритет",
            insufficient_data: "мало данных",
        },
        whatIfNeedStrategy: "Выберите стратегию",
        whatIfDefaultHypothesis: "Альтернативные параметры MA/SL/TP",
        whatIfCreated: "What-if эксперимент создан",
        whatIfReportReady: "Отчёт what-if готов",
        experimentName: "Название эксперимента",
        experimentHypothesis: "Гипотеза",
        experimentStrategyA: "Strategy A (id)",
        experimentStrategyB: "Strategy B (id)",
        experimentSplitA: "Трафик в A, %",
        experimentMinTrades: "Мин. сделок на ветку",
        experimentMaxDd: "Порог max drawdown (доля, 0..1)",
        experimentMinSlipImprove: "Мин. улучшение slippage (доля, 0..1)",
        experimentCreate: "Создать эксперимент",
        experimentCreated: "A/B эксперимент создан",
        experimentUpdated: "Статус эксперимента обновлён: {{status}}",
        experimentStart: "Запустить",
        experimentStop: "Остановить",
        experimentEmpty: "Эксперименты для режима пока не созданы.",
        experimentKpiHint: "KPI веток A/B считаются в моке по ордерам в периоде эксперимента (filled/shadow, отказы, slippage).",
        experimentBranchA: "Ветка A",
        experimentBranchB: "Ветка B",
        experimentKpiPnl: "PnL (мок)",
        experimentKpiMaxDd: "Max drawdown",
        experimentKpiAvgSlippage: "Ср. slippage, bps",
        experimentKpiRejectRate: "Reject rate",
        experimentKpiStability: "Стабильность",
        experimentKpiTrades: "Сделок",
        experimentWinnerBlock: "Авто-правило по KPI",
        experimentWinnerReady: "Критерии остановки выполнены — рекомендация активна.",
        experimentWinnerNotReady: "Критерии не выполнены — рекомендация «none/tie» до накопления данных.",
        experimentWinnerSuggested: "Рекомендуемая ветка: {{branch}}",
        experimentWinnerReasons: "Обоснование",
        experimentSuggestedTie: "ничья",
        experimentSuggestedNone: "нет рекомендации",
        experimentPromoteA: "Promote A",
        experimentPromoteB: "Promote B",
        experimentRollback: "Rollback",
        experimentOutcomeTitlePromoteA: "Подтвердить promote ветки A",
        experimentOutcomeTitlePromoteB: "Подтвердить promote ветки B",
        experimentOutcomeTitleRollback: "Подтвердить rollback",
        experimentOutcomeDescPromoteA: "Эксперимент будет завершён (completed) с фиксацией победителя — ветка A.",
        experimentOutcomeDescPromoteB: "Эксперимент будет завершён (completed) с фиксацией победителя — ветка B.",
        experimentOutcomeDescRollback: "Будет зафиксирован отказ от promote; статус эксперимента — stopped.",
        experimentOutcomeConfirm: "Подтвердить",
        experimentOutcomeSaved: "Исход A/B эксперимента сохранён.",
        experimentDecisionPromoted: "Исход: promote {{branch}}",
        experimentDecisionRolledBack: "Исход: rollback (без promote)",
        experimentDecisionLogTitle: "Decision-log",
        experimentLogEventCreated: "создание / начало журнала",
        experimentLogEventStatus: "смена статуса",
        experimentLogEventOutcome: "фиксация исхода",
        experimentLogFingerprint: "Подпись критериев (повторяемость)",
        experimentValidation: "Проверьте split/criteria: числа, split в диапазоне (0;100).",
        policyPriorityValidation: "Приоритет должен быть целым числом в диапазоне 1..100.",
        validationNumeric: "Все параметры должны быть числами.",
        validationInteger: "fast_ma, slow_ma, ma_reentry_cooldown_min, loss_avg_bottom_bars и lot должны быть целыми числами.",
        validationFastSlow: "fast_ma должен быть меньше slow_ma.",
        validationLossAvgVsStop: "Каждый порог выравнивания (pnl_pct) должен быть > 0 и меньше stop_loss.",
        validationLossAvgStepsOrder: "Пороги лестницы выравнивания должны быть неубывающими (каждый ≥ предыдущего).",
        validationLossAvgLotsMult: "Множитель лота (lots_mult) на ступени: больше 0 и не больше 20.",
        validationLossAvgStepsMax: "Не больше 10 ступеней выравнивания убытка.",
        validationLossAvgBottomBars: "Окно дна (loss_avg_bottom_bars): 0 или от 2 до 30 (1 недопустимо).",
        validationRange: "Параметр {{key}} вне диапазона {{min}}..{{max}}.",
        validationBlockMaSell: "Блокировка MA-продажи: укажите 0 или 1.",
        validationLockStopLossOnBuy: "Замок stop loss при покупке: укажите 0 или 1.",
        lossAvgStepsEmpty: "Лестница пуста — выравнивание выключено. Добавьте ступени порог % × множитель лота.",
        lossAvgStepAdd: "Добавить ступень",
        lossAvgStepRemove: "Удалить",
        paramSection: {
            signal: "Сигнал MA Cross",
            exits: "Жёсткий выход",
            maExit: "Выход по MA",
            lossAvg: "Выравнивание убытка",
            order: "Размер заявки",
        },
        param: {
            fast_ma: "Fast MA",
            slow_ma: "Slow MA",
            stop_loss: "Stop loss (%)",
            take_profit: "Take profit (%)",
            ma_sell_min_pnl_pct: "Мин. прибыль для MA SELL (%)",
            ma_reentry_cooldown_min: "Пауза после MA SELL (мин)",
            loss_avg_pct: "Выравнивание убытка (%)",
            loss_avg_max: "Макс. число выравниваний",
            loss_avg_steps: "Лестница выравнивания",
            loss_avg_step_pct: "Порог убытка % (ступень {{index}})",
            loss_avg_step_mult: "Множитель лота",
            loss_avg_bottom_bars: "Дно: окно баров",
            lot: "Lot",
            block_ma_sell_in_loss: "Не продавать по MA ниже средней цены",
            lock_stop_loss_on_buy: "Замок stop loss при покупке",
        },
        paramHint: {
            fast_ma: "Период быстрой скользящей средней. Меньше значение — чувствительнее к шуму и чаще сигналы; больше — реже входы.",
            slow_ma: "Период медленной скользящей. Должен быть больше Fast MA. Вместе задают частоту пересечений BUY/SELL.",
            stop_loss: "Принудительный SELL, если убыток позиции (с учётом комиссии) достиг порога % от средней цены входа. Меньше % — быстрее режет минус, чаще выбивает на шуме.",
            take_profit: "Принудительный SELL при достижении прибыли %. Ставьте выше round-trip комиссии (~0.6% при 0.3% на сторону), иначе «плюс» по цене уходит в минус после комиссий.",
            ma_sell_min_pnl_pct: "SELL по пересечению MA разрешён только при net PnL не ниже этого порога (%). 0 — без дополнительного ограничения (остаётся block_ma_sell_in_loss). Stop loss и take profit не затрагиваются.",
            ma_reentry_cooldown_min: "Пауза в минутах после SELL по сигналу MA Cross, в течение которой следующий auto-BUY по этому же тикеру блокируется. 0 — отключить cooldown.",
            loss_avg_pct: "Докупить lot стратегии, если убыток позиции (с комиссией) достиг этого %. 0 — выключено. Должен быть меньше stop_loss. Повторно — только после восстановления PnL выше порога и снова падения (latch), пока не исчерпан лимит.",
            loss_avg_max: "Сколько раз можно докупить за цикл открытой позиции. Счётчик сбрасывается при полном закрытии. 0 — выключено. Средства проверяет pretrade (бюджеты/лимиты); цена должна быть ниже последней продажи (или средней входа, если продаж ещё не было).",
            loss_avg_steps: "Лестница докупок: каждая ступень — порог убытка % и lots_mult к базовому lot. Индекс = loss_avg_count. Пусто — выкл. Пример: 4×1, 7×1, 10×2. Пороги неубывающие и меньше stop_loss.",
            loss_avg_bottom_bars: "После порога убытка ждать локальное дно по последним N барам: минимум окна не на последнем баре и последний бар выше предыдущего. 0 — докупать сразу при пороге; типично 3–5. Значение 1 недопустимо.",
            lot: "Число лотов в одной автозаявке. Увеличивает номинал, PnL и комиссии на сделку; на частоту сигналов не влияет. Допустимый диапазон берётся из настроек лота (Настройки → Настройки лота): {{min}}–{{max}}.",
            block_ma_sell_in_loss: "Не исполнять SELL по пересечению MA, если цена ниже breakeven (средняя + комиссии). Stop loss и take profit при этом работают как обычно.",
            lock_stop_loss_on_buy: "При покупке автоматически блокировать stop loss по тикеру. Ручная продажа и take profit остаются доступны; снять замок можно иконкой в Ордерах.",
            exitRules: "Stop loss / take profit — выход по % от средней цены позиции. Блокировка MA — не исполнять медвежий сигнал, если цена ниже средней.",
        },
        policyFieldHint: {
            priority: "Приоритет стратегии при конфликте сигналов (1–100). Выше число — выше приоритет относительно других активных стратегий.",
            conflict_policy: "Как поступать при конфликте с другой стратегией: пропустить, уменьшить размер, хедж или разворот.",
            allowed_tickers: "Список тикеров стратегии. На карточке: замок stop loss после покупки; блок покупок запрещает новые BUY (ручные и авто). Полный blacklist тикеров — в RiskPolicy режима (Настройки). Пусто = без ограничения на уровне стратегии (RiskPolicy режима всё равно действует).",
            execution_profile: "Профиль исполнения заявок стратегии (passive / balanced / aggressive): влияет на агрессивность лимитов и ожидания по слиппеджу.",
            expected_slippage_bps: "Ожидаемое проскальзывание в bps. Используется в гейтах качества: слишком большое отклонение — сигнал/заявка может быть пропущены.",
            max_spread_bps: "Максимальный допустимый спред стакана в bps. Шире спред — выше издержки; при превышении вход блокируется (нужен GetOrderBook).",
            min_liquidity_notional: "Мин. ликвидность (номинал): при доступном стакане — порог лучшего уровня (ниже → блок); также порог «крупного» ордера для auto-TWAP.",
            session_start: "Начало торгового окна стратегии (HH:mm) в указанном часовом поясе. Вместе с концом сессии задаёт календарь политики.",
            session_end: "Конец торгового окна стратегии (HH:mm). Вне окна автоторговля по календарю политики ограничена (если брокер ещё не подтвердил торговлю).",
            timezone: "IANA-часовой пояс окна стратегии (обычно Europe/Moscow для MOEX). Не путать с окном агента в «Уведомления и сессия».",
            only_rth: "Только основная сессия (RTH): стратегия ориентируется на основное окно, без расширенных интервалов политики.",
            news_blackout_minutes: "Пауза ±N минут вокруг новостных меток (0 = выкл). Снижает торговлю в моменты резких всплесков волатильности.",
        },
        preset: {
            conservative: "Пресет: Консервативный",
            balanced: "Пресет: Сбалансированный",
            aggressive: "Пресет: Агрессивный",
        },
        conflictPolicy: {
            skip: "Пропуск",
            reduce: "Снижение",
            hedge: "Хедж",
            reverse: "Реверс",
        },
        executionProfile: {
            passive: "Пассивный",
            balanced: "Сбалансированный",
            aggressive: "Агрессивный",
            twap: "TWAP",
            vwap: "VWAP",
            pov: "POV",
        },
    },
    market: {
        scheduleTitle: "Расписание биржи",
        scheduleAccordionHint: "Нажмите, чтобы раскрыть расписание",
        scheduleLoading: "Загрузка расписания…",
        scheduleExchange: "{{exchange}} · {{timezone}}",
        scheduleSourceTinvest: "T-Invest API",
        scheduleSourceFallback: "оценка",
        tradableNow: "торговля доступна",
        notTradableNow: "торговля недоступна",
        tradabilityUnknown: "статус неизвестен",
        marketOrders: "Рыночные заявки: {{available}}",
        limitOrders: "Лимитные заявки: {{available}}",
        todaySession: "Сегодня",
        exchangeTodaySession: "Сегодня на бирже",
        exchangeTodayHint: "Официальные часы MOEX по данным T-Invest; могут отличаться от окна агента в настройках.",
        agentSessionTitle: "Окно сессии агента",
        agentSessionActive: "Сейчас внутри настроенного окна агента.",
        agentSessionInactive: "Сейчас вне настроенного окна агента.",
        agentSessionDisabled: "Ограничение по окну сессии отключено (only RTH выкл.).",
        agentSessionHint: "Задаётся в Настройки → Уведомления и сессия. Pretrade стратегий использует своё расписание в карточке стратегии.",
        nonTradingDay: "Неторговый день",
        nonTradingDayShort: "Выходной",
        tradingDay: "Торговый",
        noSessionsToday: "Сессии не заданы",
        colDate: "Дата",
        colDayType: "Тип дня",
        colSessions: "Сессии (MSK)",
        blockedBecause: "По тикеру нельзя, потому что:",
        nextTradable: "Следующее окно биржи: {{when}}",
        nextTradableHint: "Точное открытие торгов по инструменту зависит от статуса T-Invest в момент начала сессии.",
    },
    checks: {
        title: "Проверки",
        hint: "Проверьте, можно ли сейчас торговать тикером через T-Invest API в выбранном режиме (лимитные и рыночные заявки отдельно).",
        tickerPlaceholder: "Тикер",
        checkButton: "Проверить",
        checking: "Проверка…",
        enterTicker: "Введите тикер",
        notFound: "Инструмент не найден или недоступен",
        instrumentTitle: "Инструмент",
        lotSize: "Размер лота: {{lot}}",
        figi: "FIGI: {{figi}}",
        source: "Данные лота: {{source}}",
        sourceTinvest: "T-Invest API",
        sourceCache: "кэш",
        sourceDefault: "значение по умолчанию",
        orderTypeLimit: "Лимитная заявка",
        orderTypeMarket: "Рыночная заявка",
        apiTrade: "Торговля через API: {{available}}",
        forQualInvestor: "Требование квала: {{value}}",
        userQualStatus: "Статус квала счёта: {{value}}",
        tradabilitySourceTinvest: "Статус: T-Invest API",
        tradabilitySourceFallback: "Статус: оценка по расписанию",
        tradabilitySourceUnavailable: "Статус: недоступен",
        tradabilitySourceCacheMiss: "Статус: ожидает кэш worker-market",
    },
    readiness: {
        title: "Готовность к торговле",
        accordionHint: "Нажмите, чтобы раскрыть чеклист",
        hint: "Чеклист перед запуском: аккаунт, токен, воркеры, kill-switch, market data и режим live (сейчас только shadow).",
        refresh: "Обновить",
        loading: "Проверка готовности…",
        checkedAt: "Проверено: {{when}}",
        activeStrategies: "Активных стратегий: {{count}}",
        workersTitle: "Воркеры",
        workerAlive: "online",
        workerDead: "offline",
        prodDisabledBadge: "без реальных денег",
        overall: {
            ready: "Готово",
            ready_shadow: "Готово к live shadow",
            not_ready: "Не готово",
        },
        status: {
            ok: "OK",
            warn: "Внимание",
            fail: "Блокер",
            info: "Инфо",
        },
    },
    orders: {
        title: "Ордера",
        backDashboard: "К обзору",
        load: "Загрузка ордеров…",
        empty: "Ордеров для выбранного режима нет.",
        colId: "ID",
        colTicker: "Тикер",
        colSide: "Сторона",
        colSignalSource: "Сигнал",
        signalSource: {
            ma_cross: "MA Cross",
            stop_loss: "Stop loss",
            take_profit: "Take profit",
            loss_avg: "Выравнивание",
            manual: "Ручная",
            broker_import: "Импорт брокера",
        },
        colQty: "Кол-во",
        colPrice: "Цена",
        colAmount: "Сумма",
        colFee: "Комиссия",
        feeSourceActual: "факт",
        feeSourceEstimated: "оценка",
        colStatus: "Статус",
        colOperationAt: "Дата операции",
        colReason: "Reason code",
        colTaxonomy: "Класс отказа",
        colQueue: "Очередь #",
        colTtf: "TTF, мс",
        colAmend: "Cancel / replace",
        colActions: "Действия",
        actionCancel: "Отменить",
        actionReplace: "Заменить цену",
        twapSlices: "{{count}} срезов",
        twapExpand: "Показать срезы",
        twapCollapse: "Свернуть срезы",
        twapSliceLabel: "срез {{index}}",
        rejectTaxonomy: {
            risk: "Риск",
            portfolio: "Портфель",
            market_data: "Рыночные данные",
            venue: "Площадка / роутер",
            validation: "Валидация",
            runtime: "Рантайм / kill-switch",
            idempotency: "Идемпотентность",
            other: "Прочее",
        },
        amendCancel: "cancel",
        amendReplace: "replace",
        amendOk: "ok",
        amendFail: "fail",
        colMode: "Режим",
        colExecutionProfile: "Профиль исполнения",
        colVenue: "Площадка",
        createTitle: "Новая заявка",
        createOpenAria: "Открыть форму новой заявки",
        createCloseAria: "Закрыть форму новой заявки",
        createExecutionProfile: "Профиль исполнения (заявка)",
        createShadowMode: "Теневой режим (виртуальное исполнение, без отправки ордера)",
        executionProfileInherit: "Как в StrategyPolicy стратегии",
        createStrategy: "Strategy ID",
        createTicker: "Тикер",
        createQty: "Количество",
        createQtyLots: "Лоты",
        createPrice: "Цена за акцию",
        lotHint: "1 лот = {{lot}} акций",
        orderAmountPreview: "≈ {{amount}} ({{shares}} акций)",
        create: "Отправить заявку",
        creating: "Отправка…",
        created: "Заявка создана: {{id}}",
        createValidation: "Заполните форму заявки корректно",
        noStrategies: "Нет стратегий для этого режима. Создайте стратегию на странице «Стратегии».",
        dailyLimitsTitle: "Дневные лимиты",
        draftExceedsNotional: "Сумма заявки ({{amount}}) превышает оставшийся запас по нотионалу ({{headroom}}).",
        filtersTitle: "Фильтры ордеров",
        filterStrategy: "Фильтр по стратегии",
        filterTicker: "Фильтр по тикеру",
        filterStatusAll: "Все статусы",
        cancelAllOpen: "Массовая отмена открытых",
        resetFilters: "Сбросить фильтры",
        cancelledCount: "Отменено открытых ордеров: {{count}}",
        orderCancelled: "Ордер {{id}} отменён.",
        orderReplaced: "Ордер {{id}}: replace по цене {{price}}.",
        positionsTitle: "Позиции и стратегии",
        positionsCardsHint: "Карточки тикеров активных стратегий: покупка, график, PnL и выход из позиции. Полная сверка ITR/брокер — в разделе «Позиции и PnL».",
        activeStrategyTickersTitle: "Тикеры активных стратегий",
        activeStrategyTickersEmpty: "Активных стратегий нет.",
        activeStrategyTickersMissingPolicy: "Нет тикеров в StrategyPolicy",
        activeStrategyTickersHint: "Быстрая покупка: MARKET BUY по lot стратегии и текущей цене (из позиции или котировки). В live потребуется подтверждение.",
        activeStrategyColTicker: "Тикер",
        activeStrategyColStrategy: "Стратегия",
        activeStrategyColLot: "Лотов",
        activeStrategyColLotSize: "Объём лота",
        activeStrategyColShares: "Акций",
        activeStrategyColPrice: "Цена",
        activeStrategyHasPosition: "В позиции: {{qty}}",
        activeStrategyBuy: "Купить",
        activeStrategyBuyAria: "Купить {{ticker}}",
        activeStrategyBuying: "Покупка…",
        dayChartOpenAria: "График цен за день: {{ticker}}",
        dayChartOpenTitle: "График за день",
        dayChartTitle: "{{ticker}} — динамика за день",
        dayChartSubtitle: "Минутные свечи за текущий день и исполненные BUY/SELL. Пустые и «мёртвые» промежутки без движения сжаты.",
        dayChartSubtitleStrategy: "Стратегия {{strategy}}. Минутные свечи за текущий день и исполненные BUY/SELL. Пустые и «мёртвые» промежутки без движения сжаты.",
        dayChartMaHint: "MA{{fast}}/MA{{slow}} поверх свечей. Пересечения MA в счётчике внизу (на графике не рисуются, чтобы не зашумлять). Сделки — маркеры B/S.",
        dayChartMaFast: "MA{{period}} быстрая",
        dayChartMaSlow: "MA{{period}} медленная",
        dayChartMaCross: "Пересечение MA",
        dayChartMaCrossUp: "Пересечение ↑",
        dayChartMaCrossDown: "Пересечение ↓",
        dayChartMaCrossCount: "пересечений MA: {{count}}",
        dayChartClose: "Закрыть",
        dayChartLoading: "Загрузка графика…",
        dayChartEmpty: "Нет данных о ценах за сегодня. История появится после накопления баров воркером.",
        dayChartPrice: "Цена",
        dayChartCandles: "Свечи",
        dayChartVolume: "Объём",
        dayChartVolumeHint: "Объём ≈ диапазон бара (тик-счётчик воркера)",
        dayChartTimeframe: "Таймфрейм",
        dayChartTimeframeMin: "м",
        dayChartOhlcOpen: "ОТКР",
        dayChartOhlcHigh: "МАКС",
        dayChartOhlcLow: "МИН",
        dayChartOhlcClose: "ЗАКР",
        dayChartBuy: "Покупка",
        dayChartSell: "Продажа",
        dayChartTradesCount: "Сделок: {{count}}",
        dayChartOutOfRange: "вне графика котировок: {{count}}",
        dayChartShares: "акц.",
        activeStrategyBuyConfirmTitle: "Купить {{ticker}}?",
        activeStrategyBuyConfirmDescription: "Будет создана MARKET BUY заявка: {{lots}} лот(ов) по ~{{price}} ₽ (стратегия {{strategy}}). Параметры — из карточки стратегии. В боевом режиме ордер уйдёт брокеру за счёт собственных средств (без принудительной маржи).",
        activeStrategyBuyCreated: "Покупка {{ticker}}: ордер {{id}}.",
        activeStrategyBuyNoPrice: "Нет текущей цены для {{ticker}}. Дождитесь котировки или укажите цену в форме «Новый ордер».",
        positionsEmpty: "Позиции отсутствуют.",
        positionsPnlTotal: "Суммарный PnL",
        posTicker: "Тикер",
        posQty: "Объём",
        posAvgPrice: "Средняя цена",
        posMarketPrice: "Текущая цена (live)",
        posBreakeven: "Breakeven",
        posPnl: "PnL",
        posPnlPct: "Текущий %",
        posPnlPctHint: "С учётом комиссии продажи (как PnL и Breakeven), не «голая» разница цен.",
        posStopLossPct: "Stop loss %",
        posTakeProfitPct: "Take profit %",
        posLossAvgPct: "Выравнивание %",
        posActions: "Действия",
        sellMenuTitle: "Продать",
        sellMenuAria: "Продать {{ticker}}",
        sellOneLot: "Продать 1 лот",
        sellAllLots: "Продать всё",
        sellLockTitle: "Заблокировать stop loss",
        sellUnlockTitle: "Разблокировать stop loss",
        sellLockAria: "Заблокировать stop loss {{ticker}}",
        sellUnlockAria: "Разблокировать stop loss {{ticker}}",
        sellLockEnabled: "Stop loss по {{ticker}} заблокирован. Ручная продажа и take profit разрешены.",
        sellLockDisabled: "Stop loss по {{ticker}} снова разрешён.",
        sellLockedHint: "Stop loss по {{ticker}} заблокирован. Снимите замок, чтобы включить стоп.",
        blockAllSellsTitle: "Заблокировать все продажи",
        unblockAllSellsTitle: "Разблокировать все продажи",
        blockAllSellsAria: "Заблокировать все продажи {{ticker}}",
        unblockAllSellsAria: "Разблокировать все продажи {{ticker}}",
        blockAllSellsEnabled: "Все продажи по {{ticker}} заблокированы: ручные, take profit и авто-SELL отклоняются.",
        blockAllSellsDisabled: "Продажи по {{ticker}} снова разрешены.",
        allSellsBlockedBadge: "Продажи заблокированы",
        allSellsBlockedHint: "По {{ticker}} заблокированы все продажи. Снимите блокировку на карточке позиции.",
        buyLockTitle: "Заблокировать покупки",
        buyUnlockTitle: "Разрешить покупки",
        buyLockAria: "Заблокировать покупки {{ticker}}",
        buyUnlockAria: "Разрешить покупки {{ticker}}",
        buyLockEnabled: "Покупки по {{ticker}} заблокированы (lock_buy стратегии). Авто и ручные BUY отклоняются.",
        buyLockDisabled: "Покупки по {{ticker}} снова разрешены.",
        buyLockedHint: "Покупки по {{ticker}} заблокированы. Снимите блок покупок на карточке или в политике стратегии.",
        transferTitle: "Перенести в другую стратегию",
        transferAria: "Перенести позицию {{ticker}} в другую стратегию",
        transferDialogTitle: "Перенос позиции {{ticker}}",
        transferDialogDescription: "Позиция останется с тем же объёмом и средней ценой. Дальше ею будет управлять выбранная стратегия (новые SL/TP/выравнивание). Runtime-состояние (loss_avg, cooldown) сбросится. История ордеров не меняется.",
        transferSelectLabel: "Целевая стратегия",
        transferConfirm: "Перенести",
        transferSuccess: "Позиция {{ticker}} перенесена в «{{strategy}}».",
        transferNoTargets: "Нет другой стратегии в этом режиме. Создайте стратегию, затем повторите перенос.",
        transferBusy: "Перенос…",
        sellLotConfirmTitle: "Продать {{ticker}}?",
        sellLotConfirmDescription: "Будет создана MARKET SELL заявка: {{lots}} лот(ов) по ~{{price}} ₽ (стратегия {{strategy}}). Подтверждая, вы соглашаетесь на выставление заявки, которая может привести к непокрытой позиции у брокера (confirmMarginTrade).",
        sellLotBusy: "Продажа…",
        sellLotCreated: "Продажа {{ticker}}: ордер {{id}}.",
        sellLotNoLots: "По позиции {{ticker}} нет целого лота для продажи (объём {{qty}}, лот {{lot}}).",
        sellLotNoStrategy: "У позиции {{ticker}} не указана стратегия.",
        status: {
            open: "Открыт",
            filled: "Исполнен",
            shadow_filled: "Теневое исполнение",
            rejected: "Отклонён",
            cancelled: "Отменён",
        },
    },
    analytics: {
        title: "Аналитика",
        backDashboard: "К обзору",
        load: "Загрузка аналитики…",
        empty: "Данные аналитики недоступны.",
        winRate: "Win rate",
        maxDd: "Max drawdown",
        sharpe: "Sharpe",
        sortino: "Sortino",
        calmar: "Calmar",
        cvar95: "CVaR 95%",
        regimeTitle: "Эффективность по режимам рынка",
        regimeHint: "Доля периода и доходность по мок-классификации режимов (stress — высокая просадка; range — низкая волатильность).",
        regimeShare: "Доля периода",
        regimeReturn: "Доходность, %",
        regimeSharpe: "Sharpe",
        regimeColumn: "Режим",
        regime: {
            range_low_vol: "Флэт, низкая волатильность",
            trend_up: "Тренд вверх",
            trend_down: "Тренд вниз",
            stress: "Стресс / высокая просадка",
        },
        equityDrawdownTitle: "Equity/Drawdown",
        equity: "Equity",
        drawdown: "Drawdown",
        equityPanel: "Капитал (Equity) и линия High-Water Mark",
        drawdownPanel: "Просадка (Drawdown), %",
        compareTitle: "Сравнение sandbox/live",
        compareCurveTitle: "Нормализованная кривая капитала (база = 100)",
        viewSingle: "Один режим",
        viewCompare: "Сравнение",
        helpEquity: "Линия капитала по времени; пунктир показывает High-Water Mark (исторический максимум).",
        helpDrawdown: "Просадка от локального максимума капитала, в процентах. Чем выше линия, тем глубже просадка.",
        helpEquityCompare: "Сравнение траектории капитала между sandbox и live на одном временном интервале.",
        helpDrawdownCompare: "Сравнение глубины просадки sandbox и live; помогает оценить стабильность исполнения.",
        helpCompareCurve: "Нормализованное сравнение (старт = 100) показывает относительную динамику двух режимов без влияния разных стартовых сумм.",
        exportCsv: "Экспорт CSV",
        exporting: "Экспорт…",
        exportDone: "Отчёт экспортирован: {{file}}",
        exportS3: "Экспорт в S3",
        exportingS3: "Загрузка в S3…",
        exportS3Done: "Отчёт в S3: {{file}}",
        exportS3Disabled: "S3 export не настроен на сервере",
    },
    pro: {
        riskCockpitTitle: "Риск-коворк (cockpit)",
        riskCockpitHint: "Использование дневных лимитов и экспозиция по тикерам.",
        openExecutionJournal: "Открыть журнал исполнения",
        unrealizedPnl: "Нереализ. PnL",
        realizedPnlToday: "Реализ. PnL за сегодня",
        dailyLossHeadroom: "Запас по дневному убытку",
        notionalHeadroom: "Запас по нотионалу",
        exposureNotional: "Экспозиция, нотионал",
        pctOfMax: "% от макс.",
        noExposureRows: "Нет строк по тикерам.",
        executionQualityTitle: "Качество исполнения",
        executionQualityHint: "Метрики слиппеджа и жизни заявки (мок).",
        expectedSlippageBps: "Ожидаемый слиппедж, б.п.",
        realizedSlippageBps: "Реализованный слиппедж, б.п.",
        avgSlippageBps: "Сред. слиппедж, б.п.",
        baselineRealizedSlippageBps: "Baseline realized slippage, б.п.",
        slippageImprovementKpi: "Улучшение к baseline (факт / цель)",
        shadowVsLiveSlippage: "Shadow vs live (слиппедж)",
        modeSwitchNoDowntimeKpi: "Переключение режимов без простоя (downtime)",
        shadowLiveDivergenceMeasuredKpi: "Расхождение shadow/live измерено",
        partialFillRate: "Доля частичных исполнений",
        avgOrderLifetime: "Ср. время жизни заявки, с",
        avgLatencyMs: "Средняя задержка исполнения, мс",
        avgFeeTaxRateBps: "Комиссии и налоги, б.п.",
        marketLimitShare: "Доля market / limit",
        qualitySampleSize: "Размер выборки",
        liveKillTitle: "Включить kill switch в боевом режиме?",
        liveKillDescription: "Остановятся новые сигналы, заявки по политике, автоторговля в live до отключения kill switch. Продолжить?",
        confirmDanger: "Подтвердить",
        notificationsTitle: "Уведомления и сессия",
        notificationsHint: "События для email-оповещений (в моке только симуляция, письма не отправляются).",
        notifyKillSwitch: "Письмо при kill switch",
        notifyApiDown: "Письмо при сбоях API / связи",
        notifyCriticalReason: "Письмо при критичных reason_code риск/исполнение",
        scheduleTitle: "Окно сессии",
        sessionStart: "Начало сессии (лок.)",
        sessionEnd: "Конец сессии (лок.)",
        timezone: "Часовой пояс (IANA)",
        onlyRth: "Только основная сессия (RTH)",
        fieldHint: {
            sessionStart: "Локальное начало окна агента (HH:mm) в выбранном timezone. Участвует в проверке tradability вместе со статусом T-Invest.",
            sessionEnd: "Локальный конец окна агента. Вне окна новые заявки могут блокироваться, даже если биржа формально открыта.",
            timezone: "Часовой пояс окна агента (например Asia/Yekaterinburg). Не заменяет окно StrategyPolicy в Europe/Moscow.",
            onlyRth: "Ограничить окно агента правилами основной сессии. На частоту MA-сигналов влияет слабее, чем лимиты Risk и параметры стратегии.",
            lotMin: "Минимальное количество лотов, разрешённое в одной заявке.",
            lotMax: "Максимальное количество лотов, разрешённое в одной заявке.",
            lotStep: "Шаг (инкремент) для значений лотов.",
        },
        prefsMockNote: "В мок-режиме настройки хранятся в памяти на время сессии.",
        savePrefs: "Сохранить",
        liveStrategyConfirmActivateTitle: "Активировать стратегию в боевом режиме?",
        liveStrategyConfirmActivateDescription: "Активная в live стратегия может выставлять реальные заявки. Проверьте лимиты и политику. Продолжить?",
        liveStrategyConfirmDeactivateTitle: "Деактивировать стратегию в боевом режиме?",
        liveStrategyConfirmDeactivateDescription: "Новые сигналы прекратятся; рабочие заявки могут потребовать ручного контроля по политике. Продолжить?",
        liveCancelAllTitle: "Массовая отмена заявок в боевом режиме?",
        liveCancelAllDescription: "Отмена распространяется на заявки по текущим фильтрам. Подтвердить?",
        lotSettingsTitle: "Настройки лота",
        lotMin: "Мин. лотов",
        lotMax: "Макс. лотов",
        lotStep: "Шаг лота",
    },
    activation: {
        title: "Нет доступа к торговому контуру",
        lead: "Вы вошли как {{email}}. Торговые инструменты откроются после активации администратором.",
        hintPending: "Ожидайте активации. После решения администратора нажмите «Проверить статус».",
        hintSuspended: "Доступ приостановлен. Обратитесь к администратору.",
        apiNote: "На real API неактивные учётные записи получают ошибку при обращении к торговому контуру.",
        refreshStatus: "Проверить статус",
    },
    admin: {
        title: "Пользователи",
        navLabel: "Разделы администрирования",
        nav: {
            users: "Пользователи",
            limits: "Лимиты T-Invest",
        },
        limits: {
            title: "Лимиты T-Invest API",
            loading: "Загрузка анализа…",
            summary: "Сводка",
            overall: "Статус",
            worstRatio: "Загрузка (worst ratio)",
            tariffToken: "Токен тарифа",
            watchlist: "Тикеров в watchlist",
            warmupReady: "готов",
            warmupPending: "прогрев",
            warmupStep: "Шаг прогрева",
            warmupTitle: "Прогрев кэша (FIGI + trading status)",
            warmupDisabled: "MARKET_WARMUP_ENABLED=false — гейт автоторговли выключен.",
            warmupAutoRefresh: "Обновление каждые 10 с",
            warmupInProgress: "Идёт прогрев",
            warmupModeDisabled: "Брокер выключен для режима",
            warmupFigi: "FIGI (FindInstrument)",
            warmupStatus: "Trading status",
            warmupNoTickers: "Нет тикеров в watchlist — ready без прогрева.",
            warmupLastStep: "Последний шаг worker",
            warmupUpdated: "Обновлено",
            warmupReadyAt: "Ready с",
            warmupSkipped: "Пропуск",
            warmupHint: "Пока не ready, worker-strategy не выставляет авто-ордера. Ускорить: make warmup-market-cache или кнопка «Шаг прогрева». Dev: MARKET_WARMUP_OVERRIDE=true.",
            modeBlock: "Режим {{mode}}",
            colMethod: "Метод / пул",
            colUsed: "Запросов/мин",
            colLimit: "Лимит",
            colRatio: "Доля",
            colStatus: "Статус",
            metrics: "Счётчики API (24ч)",
            venueRouting: "Venue routing (24ч)",
        },
        filters: "Фильтры",
        search: "Поиск",
        searchPlaceholder: "Email, имя, id",
        statusFilter: "Статус",
        statusAll: "Все",
        statusPending: "Ожидает активации",
        statusActive: "Активен",
        statusSuspended: "Приостановлен",
        applyFilters: "Применить",
        loading: "Загрузка списка…",
        empty: "Нет пользователей по фильтрам.",
        tableLabel: "Учётные записи",
        colEmail: "Email",
        colId: "ID",
        copyId: "Скопировать ID",
        copyIdFailed: "Не удалось скопировать ID",
        colRegistered: "Регистрация",
        colStatus: "Статус",
        colRoles: "Роли",
        colSandbox: "Песочница",
        sandboxOn: "Вкл",
        sandboxOff: "Выкл",
        sandboxHint: "Без песочницы пользователь работает только в live; MD sandbox не запрашивается",
        colNote: "Заметка",
        colActions: "Действия",
        actionActivate: "Активировать",
        actionSuspend: "Приостановить",
        actionRevoke: "Снять доступ (ожидание)",
        actionSaveRoles: "Сохранить роли",
        selfRoleHint: "Свою роль admin снять нельзя",
        role: {
            trader: "Трейдер",
            admin: "Администратор",
            auditor: "Аудитор",
        },
        pagination: "Строки {{from}}–{{to}} из {{total}}",
        page: "Стр. {{page}} из {{pageCount}}",
        prev: "Назад",
        next: "Вперёд",
        activation: {
            pending_activation: "Ожидает",
            active: "Активен",
            suspended: "Заблокирован",
        },
    },
    pnlReport: {
        title: "Позиции и PnL",
        subtitle: "Открытые позиции ITR и результат по тикерам (ITR / брокер / сверка) в одном списке карточек. Ручные сделки на брокере выделены.",
        period: { all: "Всё время", today: "Сегодня", custom: "Период" },
        periodAll: "За всё время по сделкам ITR",
        periodToday: "За текущий день (UTC)",
        applyPeriod: "Применить",
        brokerUnavailable: "Данные брокера недоступны — подключите токен и синхронизируйте портфель. Показаны только данные ITR.",
        itrRealized: "ITR реализованный",
        brokerRealized: "Брокер реализованный",
        diff: "Разница (ITR − брокер)",
        itrUnrealized: "ITR нереализованный",
        byTicker: "Позиции и тикеры",
        cardsHint: "Сначала открытые позиции, ниже — тикеры только с историей PnL. Карточка: позиция + сверка ITR/брокер.",
        openPositionsCount: "Открытых: {{count}}",
        cardHeroOpen: "Нереализованный",
        cardHeroRealized: "Реализованный ITR",
        cardOpenQty: "Открыто {{qty}}",
        cardShortQty: "шорт {{qty}}",
        cardClosed: "Нет позиции",
        cardStrategies: "Стратегий: {{count}}",
        cardSells: "Продаж ITR / брокер",
        cardNoPnlRow: "Нет строк PnL за период — показана только открытая позиция.",
        empty: "Нет позиций и сделок за выбранный период.",
        colTicker: "Тикер",
        colItrRealized: "ITR реал.",
        colBrokerRealized: "Брокер реал.",
        colDiff: "Δ",
        colItrSells: "ITR продаж",
        colBrokerSells: "Брокер продаж",
        colManual: "Ручные",
        colItrUnrealized: "ITR нереал.",
        colBrokerUnrealized: "Брокер yield",
        colDate: "Дата",
        colSide: "Сторона",
        colQty: "Кол-во",
        colPayment: "Сумма",
        colCommission: "Комиссия",
        colOrderId: "Order ID",
        manualBadge: "ручные",
        manualCounts: "покупок {{buys}}, продаж {{sells}}",
        manualTitle: "Ручные операции на брокере",
        manualHint: "Операции брокера без связи с ордером ITR (тикер, сторона, объём, время, цена). API брокера не отдаёт orderId — сопоставление по сделкам в БД.",
        manualEmpty: "Ручных операций за период нет.",
        noOrderId: "нет ID",
        brokerSyncedAt: "Снимок портфеля брокера: {{at}}",
    },
    journal: {
        title: "Журнал исполнения",
        subtitle: "Трассировка по тегам: сигнал → риск-гейт → роутер → площадка; фильтр по тегу для поиска узких мест.",
        tabExecution: "Исполнение",
        tabSkips: "Тихие пропуски",
        skipsHint: "Сигналы, которые не дошли до заявки или были отклонены брокером до сохранения ордера. Повторы агрегируются (hit_count).",
        skipsEmpty: "Нет записей о тихих пропусках по текущим фильтрам.",
        skipsMeta: "Источник: {{source}} · повторов: {{hits}} · первый: {{first}}",
        skipScheduleTitle: "Расписание биржи",
        skipMainWindow: "Основная сессия",
        skipEveningWindow: "Вечерняя сессия",
        skipTradingStatus: "Статус инструмента",
        skipTradabilitySource: "Источник статуса",
        skipBlockedReasons: "Причины блокировки",
        skipBrokerMessage: "Сообщение брокера",
        skipScheduleSource: {
            tinvest: "T-Invest API",
            cache: "кэш Redis",
            fallback: "fallback (дефолт)",
        },
        filters: "Фильтры",
        causalFilterHint: "Быстрый фильтр по причинно-следственному тегу (есть шаг с этим тегом в трассе).",
        causalFilterAll: "Все теги",
        filterStrategy: "ID стратегии",
        filterTicker: "Тикер",
        dateFrom: "С",
        dateTo: "По",
        applyFilters: "Применить",
        exportCsv: "Экспорт CSV",
        loading: "Загрузка журнала…",
        empty: "Нет записей по текущим фильтрам.",
        shadowVsLiveTitle: "Сравнение shadow vs live",
        shadowVsLiveSummary: "Теневых: {{shadow}}, live: {{live}}, всего исполнений: {{total}}.",
        shadowBadge: "SHADOW",
        stage: {
            signal: "Сигнал",
            risk_gate: "Риск-гейт",
            router: "Роутер",
            venue: "Площадка",
        },
        stepStatus: {
            ok: "ОК",
            pending: "В ожидании",
            rejected: "Отклонён",
        },
    },
    portfolioComparison: {
        title: "Портфель: брокер и ITR",
        hint: "Слева — снимок счёта T-Invest (GetPortfolio/GetPositions). Справа — позиции и PnL только по ордерам ITR Agent.",
        refresh: "Обновить",
        refreshing: "Обновление…",
        sync: "Синхронизировать с T-Invest",
        syncing: "Синхронизация…",
        syncInProgress: "Запрашиваем портфель у брокера…",
        syncStepToken: "Проверка live/sandbox-токена и счёта",
        syncStepPortfolio: "OperationsService/GetPortfolio — стоимость портфеля",
        syncStepPositions: "OperationsService/GetPositions — позиции и доступные средства",
        syncStepSave: "Сохранение снимка в broker_portfolio_snapshots",
        syncSuccess: "Снимок брокера обновлён",
        importTrades: "Импорт сделок брокера",
        importingTrades: "Импорт…",
        importTradesHint: "Несматченные BUY/SELL с T-Invest за 30 дней → filled-ордера ITR и пересчёт позиций.",
        importConfirmTitle: "Импортировать сделки брокера?",
        importConfirmDescription: "Будут созданы синтетические исполненные ордера для операций, которых нет в ITR (стратегия «брокер / вручную»). Уже учтённые сделки пропускаются. Режим: текущий (sandbox/live).",
        importSuccess: "Импорт: +{{imported}} (просмотрено {{scanned}}, совпало {{matched}}, уже было {{already}}).",
        reconcileTrades: "Пересинхронизировать сделки",
        reconcilingTrades: "Пересинхронизация…",
        reconcileTradesHint: "Обновить fee, цену и метаданные уже импортированных ордеров по операциям T-Invest (90 дней, с trades).",
        reconcileConfirmTitle: "Пересинхронизировать сделки брокера?",
        reconcileConfirmDescription: "Существующие ордера ITR (включая ранее импортированные) будут сверены с операциями брокера: комиссия, цена исполнения, broker_trade_id. Позиции не пересчитываются — при расхождении qty используйте выравнивание после reconcile.",
        reconcileSuccess: "Reconcile: обновлено {{reconciled}}, без изменений {{unchanged}}, новых импортов {{imported}} (просмотрено {{scanned}}).",
        alignPositions: "Выровнять позиции по брокеру",
        aligningPositions: "Выравнивание…",
        alignPositionsHint: "Аварийно: qty и средняя цена ITR = снимок брокера. История ордеров не восстанавливается.",
        alignConfirmTitle: "Выровнять позиции по брокеру?",
        alignConfirmDescription: "Позиции ITR будут приведены к снимку T-Invest (создание/обновление/удаление). Рекомендуется сначала импортировать сделки. Действие необратимо для локальных qty/avg.",
        alignSuccess: "Выравнивание: обновлено {{updated}}, создано {{created}}, удалено {{removed}}.",
        loading: "Загрузка портфеля…",
        syncedAt: "обновлено {{when}}",
        brokerTitle: "Брокер (T-Invest)",
        itrTitle: "ITR (наши ордера)",
        total: "Стоимость портфеля",
        available: "Доступно",
        expectedYield: "Ожидаемая доходность",
        exposure: "Экспозиция",
        unrealized: "Нереализованный PnL",
        noPositions: "Нет открытых позиций",
        brokerUnavailable: "Снимок брокера ещё не получен. Нажмите «Синхронизировать с брокером».",
        colTicker: "Тикер",
        colQty: "Qty",
        colPrice: "Цена",
        colValue: "Стоимость",
        colPnl: "PnL",
        syncStatus: {
            ok: "Синхронизация актуальна",
            stale: "Снимок устарел — запустите синхронизацию",
            unavailable: "Нет данных брокера",
        },
    },
    tradingPnl: {
        title: "Результат торговли",
        hint: "Только исполненные сделки и открытые позиции. Пополнения и выводы не учитываются.",
        modeHint: "Внутренняя модель ITR Agent — не брокерский счёт.",
        realizedSection: "Зафиксировано сделками",
        realizedHint: "Меняется только при исполнении ордеров. При остановке по лимиту остаётся неизменным.",
        unrealizedSection: "Оценка открытых позиций",
        unrealizedHint: "По текущей рыночной цене; обновляется с котировками, даже без новых сделок.",
        realizedTotal: "Реализовано всего",
        today: "Реализовано за сегодня",
        unrealized: "Нереализованный PnL",
        combinedFootnote: "Совокупная оценка (реализовано + нереализовано): {{value}} — меняется вместе с рынком.",
    },
    limits: {
        exhausted: "Лимит исчерпан",
        warning: "Лимит почти исчерпан",
        dailyNotional: "Дневной нотионал",
        dailyTrades: "Сделки за день",
        dailyLoss: "Дневной убыток",
    },
    strategyGroups: {
        title: "Группы стратегий",
        namePlaceholder: "Название группы",
        nameRequired: "Укажите название группы.",
        create: "Новая группа",
        createSection: "Создание группы",
        createOpen: "Создать группу",
        createCollapse: "Скрыть",
        statusCreated: "Группа создана",
        statusStrategyMoved: "Стратегия перемещена",
        ungrouped: "Без группы",
        deleteConfirm: "Удалить группу?",
        deleteDesc: "Все стратегии будут перемещены в группу 'Без группы'.",
        delete: "Удалить группу",
        newGroup: "Новая группа",
        groupCreated: "Группа создана",
        groupUpdated: "Группа обновлена",
        groupRemoved: "Группа удалена",
        groupRequired: "Введите название группы",
        groupRename: "Переименовать",
        groupDelete: "Удалить группу",
        groupDeleteConfirm: "Удалить группу и переместить все стратегии в «Без группы»?",
        groupCreated: "Группа создана",
        groupUpdated: "Группа обновлена",
        groupRemoved: "Группа удалена",
        moveStrategy: "Переместить в группу",
    },
    strategySearch: {
        placeholder: "Поиск по тикеру или названию…",
        noResults: "Стратегии не найдены",
        resultsCount: "Найдено: {{count}}",
    },
};
